export function IconDiamondGrey() {
  return (
    <g transform="scale(0.5)">
      <path
        d="M69.1752 17.5016L61.3502 14.4766L49.2252 14.5766L48.8002 14.4766L48.5002 14.6016L31.1752 14.7516L31.0502 14.7016L30.8752 14.7516L18.6502 14.8516L10.2752 18.1266L0.350195 28.5016L0.200195 29.1266L3.3752 32.7516L8.9752 39.1266L30.3502 57.6516L40.2002 65.4766L50.4252 57.0266L70.5752 39.1266L76.7752 32.3766L79.8002 29.1266V27.9516L69.1752 17.5016Z"
        fill="#EEEFEF"
      />

      <g stroke="#656F74" strokeWidth="0.333125">
        <path d="M61.3502 14.5234L18.6502 14.9234L10.2752 18.1734L0.350195 28.5484L0.200195 29.1734L3.3752 32.8234L8.9502 39.1734L30.3502 57.6984L40.2002 65.5234L50.4252 57.0734L70.5752 39.1734L76.7752 32.4234L79.8002 29.1734V28.0234L69.1752 17.5484L61.3502 14.5234Z" />

        <path d="M50.7253 56.7008L68.5503 38.5508L46.5503 57.9258L51.9003 38.5508L40.2003 58.1008L27.9503 38.6258L33.5253 57.9258L11.6753 39.1008L27.7253 55.3758" />
        <path d="M61.8252 38.7266L46.5502 57.9266L40.2002 65.5266L33.5252 57.9266L18.3252 39.4016" />
        <path d="M40.2005 65.5258V38.6258L32.7505 32.4258L27.9505 38.6258L19.2005 32.6758L18.3255 39.4008L9.02549 32.5258L11.6755 39.1008L3.37549 32.8258" />
        <path d="M40.2006 38.6258L47.3256 32.5258L51.9006 38.5508L60.7256 32.3508L61.8256 38.7258L71.0256 32.2758L68.5506 38.5508L76.3756 32.7508L76.5756 28.9258L71.0256 32.2758L68.0256 29.0258L60.7256 32.3508L55.1506 29.1758L47.3256 32.5258L39.9506 29.3258L32.7506 32.4258L24.8506 29.3758L19.2006 32.6758L12.0506 29.3758L9.02559 32.5258L3.47559 29.3508L3.22559 32.4258L0.975586 29.0258" />
        <path d="M0.200195 29.1734L0.975195 29.0234L3.4502 29.2484H6.9502L12.0502 29.3234L17.8002 29.1734L24.8502 29.3234L32.1252 29.1734L39.9502 29.3234L47.7002 28.7234L55.1502 29.1734L61.9002 28.7984L68.1002 28.9484L72.9002 28.6484L76.7002 28.7984L78.7002 28.6484L79.8002 29.1734" />
        <path d="M0.350586 28.55L3.30059 27.775L7.17558 28.875L11.7506 28.1L17.8756 28.725L24.6256 27.475L32.1256 28.65L39.8006 28.175L47.3256 28.4L55.3756 27.175L61.9006 28.4L67.7756 27.95L72.8256 28.25L76.4506 27L78.9506 28.325L79.8006 28.025" />

        <path d="M47.3257 32.5266L47.7007 28.7266" />
        <path d="M32.7505 32.4258L32.1255 29.1758" />
        <path d="M19.2003 32.6758L17.8003 29.1758" />
        <path d="M9.10029 32.4258L7.17529 29.3008" />
        <path d="M60.7251 32.3508L61.9001 28.8008" />
        <path d="M71.0254 32.2734L72.9004 28.6484" />
        <path d="M76.7749 32.4234L78.6999 28.6484" />

        <path d="M69.1748 17.5508L76.4498 27.0008L60.4998 17.5508L55.3748 27.1758L39.9248 17.9508" />
        <path d="M10.2753 18.1742L3.30029 27.7742L19.2003 17.9492L24.6253 27.3992L39.9253 17.9492V28.1742" />
        <path d="M61.3499 14.5234L60.4999 17.5484L48.7999 14.6984L39.9249 17.9484L31.0249 14.8734L19.1999 17.9484L18.6499 14.9234" />

        <path d="M7.17529 28.875L15.5503 22.75L17.8753 28.725" />
        <path d="M32.1255 28.6492L39.8755 22.4492L47.3255 28.3992" />
        <path d="M61.8999 28.3992L64.1499 22.1992L72.8249 28.2492" />
        <path d="M67.7755 27.9508L64.1505 22.2008L60.5005 17.5508" />
        <path d="M19.2005 17.9492L15.5505 22.7492L11.7505 28.0992" />
      </g>

      <g fill="#656F74" opacity="0.12">
        <path d="M46.6497 32.6484L40.1247 38.0734L33.4497 32.5234L46.6497 32.6484Z" />
        <path d="M28.8252 38.6008L39.4002 56.1008L32.7252 33.5508L28.8252 38.6008Z" />
        <path d="M51.2752 38.5734L40.7002 56.0734L47.3752 33.5234L51.2752 38.5734Z" />
        <path d="M41.6748 17.9484L48.7998 15.2734L59.6998 17.9484H41.6748Z" />
        <path d="M63.8501 19.0766L69.5001 18.8516L74.4501 25.4016L63.8501 19.0766Z" />
        <path d="M16.1752 19.0766L10.5252 18.8516L5.5752 25.4016L16.1752 19.0766Z" />
        <path d="M10.4248 37.0266L3.9748 30.4766L3.7998 32.5266L10.4248 37.0266Z" />
        <path d="M22.2746 47.475L10.3496 34.25L12.2246 38.8L22.2746 47.475Z" />
        <path d="M58 47.0258L69.925 33.8008L68.05 38.3508L58 47.0258Z" />
        <path d="M69.4248 37.0266L75.8748 30.4766L76.0498 32.5266L69.4248 37.0266Z" />
        <path d="M61.5503 32.8266L67.7003 29.8516L62.2253 37.7516L61.5503 32.8266Z" />
        <path d="M50.675 45.4492L58.975 41.4492L48.5 54.6492L50.675 45.4492Z" />
        <path d="M29.3 45.4492L21 41.4492L31.475 54.6492L29.3 45.4492Z" />
        <path d="M18.3746 32.9242L12.2246 29.9492L17.6996 37.8242L18.3746 32.9242Z" />
        <path d="M22.4004 25.1758L18.9254 18.8008L16.4004 22.4508L22.4004 25.1758Z" />
        <path d="M57.1753 25.1758L60.6503 18.8008L63.1753 22.4508L57.1753 25.1758Z" />
        <path d="M47.4501 27.8766L45.8501 22.2266L53.7501 27.0266L47.4501 27.8766Z" />
        <path d="M32.1501 28.1516L33.7501 22.4766L25.8501 27.2766L32.1501 28.1516Z" />
        <path d="M38.2003 17.9484L31.0503 15.2734L20.1753 17.9484H38.2003Z" />
      </g>
    </g>
  )
}
